<template>
  <div>
      <v-chip  v-if="fareFeatures"
        v-for="(feature, index) in fareFeatures.features"
        :key="index"
        justify-center
        style="text-align: center; padding: 6px"
      >
        {{ feature }}
      </v-chip>
      </div>
</template>

<script>
export default {
  name: "AjetFareFeatures",
  props: {
    fareName: {
      type: String,
      required: true,
    },
    flightType: {
      type: String,
      default: "domestic", // domestic, international, cyprus
    },
  },
  data() {
    return {
      ajetFares: {
        "BASIC": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
        },
        "ECOJET": {
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "15 kg Uçak Altı Bagajı",
            ],
          },
        },
        "FLEX": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "20 kg Uçak Altı Bagajı",
            ],
          },
        },
        "PREMIUM": {
          domestic: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
          international: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
          cyprus: {
            features: [
              "1 Adet Kabin Bagajı (55x40x23 cm, Max 8 kg)",
              "1 Adet Kişisel Eşya (Max 4 kg)",
              "25 kg Uçak Altı Bagajı",
            ],
          },
        },
      },
    };
  },
  computed: {
    fareFeatures() {
      const normalizedFareName = this.fareName
        ? this.fareName.toUpperCase().trim()
        : '';

      if (!normalizedFareName || !this.ajetFares[normalizedFareName]) {
        return null;
      }

      const fare = this.ajetFares[normalizedFareName];

      // Check if flight type specific data exists
      if (fare[this.flightType]) {
        return fare[this.flightType];
      }

      // Fallback to domestic if no specific type found
      return fare.domestic || fare.international || null;
    },
  },
};
</script>

<style scoped>
</style>
